import { connect } from 'react-redux'
import Discussion from './discussion'
import { getFetchContributionsRequest } from '../../../../../stores/discussion/discussion.selectors'

const mapStateToProps = state => {
  const fetchRequest = getFetchContributionsRequest(state)
  return {
    pending: fetchRequest.pending
  }
}

export default connect(
  mapStateToProps,
  null
)(Discussion)
